export function getAuthorizationProperties(token, additionalHeaders = {}) {
    let headers = new Headers({ ...additionalHeaders, 'Authorization': 'Bearer ' + token });
    return { headers };
}



export default {
    getAuthorizationProperties,
}